import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TokenizationService {

  constructor(
    private _utilsService: UtilsService
  ) { }

  getAuthKey(brandId: string, customerId: string) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.authKey);
    return this._utilsService.postAPICall(url, {
      brand_id: brandId,
      customer_id: customerId
    }, this._utilsService.setHeaders())
  }
}
